import React from 'react';

import DatePickerField from 'Lib/components/form/DatePickerField';
import Form from 'Lib/components/form/Form';
import isEmpty from 'Lib/utilities/isEmpty';

import { useFilter } from './useFilter';

function AsOfDate(props) {
    const filter = useFilter(
        props,
        () => {
            const theDate = props.context.getFilterValue(props.name);
            bindValue(theDate);
        },
        handleClear,
        handleCancel
    );

    const { value, setValue, handleToggle, setFilterValue, renderMenuButtons } = filter;

    const handleClear = form => {
        if (form) {
            form.setFieldValue('theDate', null);
        }

        setFilterValue(props.name, null);
        setValue(null);
    };

    const handleCancel = () => {
        handleToggle();
    };

    const { placeholder = 'Select a Date' } = props;

    const handleSubmit = values => {
        const { theDate } = values;

        bindValue(theDate);
        setFilterValue(props.name, theDate);
        handleToggle();
    };

    const bindValue = theDate => {
        if (isEmpty(theDate)) {
            return;
        }

        const label = `${theDate}`;

        setValue({
            value: theDate,
            label
        });
    };

    return filter.render(
        <div
            className="searchable-list-filter-menu"
            style={{
                padding: '10px',
                minWidth: '300px'
            }}
        >
            <Form
                initialValues={{
                    theDate: value
                }}
                onSubmit={handleSubmit}
                render={form => {
                    return (
                        <form onSubmit={form.handleSubmit}>
                            <DatePickerField placeholder={placeholder} name={'theDate'} label={props.label} hideLabel={true} />
                            {renderMenuButtons({ handleCancel, handleClear, form })}
                        </form>
                    );
                }}
            />
        </div>
    );
}

export default AsOfDate;
